<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">订单详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
   <div class="ordertoppage">
      <img class="ordericonimg" src="/static/newprojecticon/yizhifu.png"  />
      <div class="ordericontext" v-if="list.order_status_str">{{list.order_status_str}}</div>
      <div class="ordericontext" v-if="currentTime">剩余: {{currentTime}}</div>
    </div>
    <div class="orderdetaillist" v-if="list.type=='mall'">
      <div class="order_product_address" v-if="list.address">
        <img class="order_product_addressicon" src="/static/weizhi.png" />
        <div class="order_product_addressmesg">
          <div class="order_product_addressname">
            <div>{{list.address.addressee}}</div>
            <div class="order_product_addressphone">{{list.address.mobile}}</div>
          </div>
          <div class="order_product_addressdetail">{{list.address.province}}{{list.address.city}}{{list.address.district}}{{list.address.address}}</div>
        </div>
      </div>
      <div class="order_product_detail">
        <div class="order_product_detailimg">
          <img class="order_product_detailthum" :src="list.product ? list.product.thumb : ''" />
        </div>
        <div class="order_product_detailmesg">
          <div class="order_product_detailproname">{{list.product ? list.product.name : ''}}</div>
          <div class="order_product_detailbottom">
            <div class="order_product_detailguige">规格：默认规格</div>
            <div class="order_product_detailprice">￥{{list.amount}}</div>
          </div>
        </div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单金额</div>
        <div class="orderdetailvalue" style="color: #029DFF;">￥{{list.amount}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">实付金额</div>
        <div class="orderdetailvalue" style="color: #029DFF;">￥{{list.paid_amount}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">支付方式</div>
        <div class="orderdetailvalue">{{list.pay_type_str}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单编号</div>
        <div class="orderdetailvalue">{{list.order_no}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单时间</div>
        <div class="orderdetailvalue">{{list.created_at}}</div>
      </div>
      <div class="orderdetailbox" v-if="list.remark">
        <div class="orderdetailname">备注</div>
        <div class="orderdetailvalue">{{list.remark}}</div>
      </div>
      <div class="orderreturnindex" @click="pageToIndex">返回首页</div>
    </div>
    <div class="orderdetaillist" v-else>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单名称</div>
        <div class="orderdetailvalue">{{list.type=='second_order' ? list.name : list.product_name && list.product_name}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单编号</div>
        <div class="orderdetailvalue">{{list.order_no}}</div>
      </div>
      <div class="orderdetailbox" v-if="list.type=='online'">
        <div class="orderdetailname">充值账号</div>
        <div class="orderdetailvalue">{{list.recharge_number}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单时间</div>
        <div class="orderdetailvalue">{{list.created_at}}</div>
      </div>
      <div class="orderdetailbox" v-if="list.type!='second_order'">
        <div class="orderdetailname">商品总价</div>
        <div class="orderdetailvalue">￥{{list.product_price}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单金额</div>
        <div class="orderdetailvalue">￥{{list.amount}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">实付金额</div>
        <div class="orderdetailvalue">￥{{list.paid_amount}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">支付方式</div>
        <div class="orderdetailvalue">{{list.pay_type_str}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">支付状态</div>
        <div class="orderdetailvalue">{{list.pay_status_str}}</div>
      </div>
      <div class="orderdetailbox" v-if="list.orderStatus == 40">
        <div class="orderdetailname">待支付</div>
        <div class="orderdetailvalue">￥{{list.orderMoney}}</div>
      </div>
      <div class="orderdetailbox" v-if="list.orderStatus == 40">
        <div class="orderdetailname">取消时间</div>
        <div class="orderdetailvalue">{{list.cancelTime}}</div>
      </div>
      <div class="orderdetailbox">
        <div class="orderdetailname">订单状态</div>
        <div class="orderdetailvalue">{{list.order_status_str}}</div>
      </div>
      <div v-if="list.recharge_data">
        <div v-for="(item,index) in JSON.parse(list.recharge_data)">
          <div class="orderdetailbox" v-if="item.goods_number">
            <div class="orderdetailname">卡号</div>
            <div class="orderdetailvalue">{{item.goods_number}}</div>
          </div>
          <div class="orderdetailbox" v-if="item.goods_password">
            <div class="orderdetailname">卡密</div>
            <div class="orderdetailvalue">{{item.goods_password}}</div>
          </div>
          <div class="orderdetailbox" v-if="item.goods_link">
            <div class="orderdetailname">链接</div>
            <div class="orderdetailvalue">{{item.goods_link}}</div>
          </div>
          <div class="orderdetailbox" v-if="item.effective_time">
            <div class="orderdetailname">有效期</div>
            <div class="orderdetailvalue">{{item.effective_time}}</div>
          </div>
        </div>
      </div>
      <div class="orderreturnindex" @click="pageToIndex">返回首页</div>
    </div>

   <!-- <div class="page_top list_top">
      <div class="icon">
        <img src="/static/newprojecticon/yizhifu.png" class="iconimg" />
        <span v-if="list.order_status_str" class="icon_text">{{list.order_status_str}}</span>
        <span v-if="currentTime">剩余: {{currentTime}}</span>
      </div>
    </div>
    <div class="order_preview" v-if="list.type=='mall'">
      <div class="order_preview_bd">
        <div class="order_product_address" v-if="list.address">
          <img class="order_product_addressicon" src="/static/weizhi.png" />
          <div class="order_product_addressmesg">
            <div class="order_product_addressname">
              <div>{{list.address.addressee}}</div>
              <div class="order_product_addressphone">{{list.address.mobile}}</div>
            </div>
            <div class="order_product_addressdetail">{{list.address.province}}{{list.address.city}}{{list.address.district}}{{list.address.address}}</div>
          </div>
        </div>
        <div class="order_product_detail">
          <div class="order_product_detailimg">
            <img class="order_product_detailthum" :src="list.product ? list.product.thumb : ''" />
          </div>
          <div class="order_product_detailmesg">
            <div class="order_product_detailproname">{{list.product ? list.product.name : ''}}</div>
            <div class="order_product_detailbottom">
              <div class="order_product_detailguige">规格：默认规格</div>
              <div class="order_product_detailprice">￥{{list.amount}}</div>
            </div>
          </div>
        </div>
        <div class="order_preview_item1">
          <div class="order_preview_label">订单金额</div>
          <div class="order_preview_value" style="color: #029DFF;">￥{{list.amount}}</div>
        </div>
        <div class="order_preview_item1">
          <div class="order_preview_label">实付金额</div>
          <div class="order_preview_value" style="color: #029DFF;">￥{{list.paid_amount}}</div>
        </div>
        <div class="order_preview_item1">
          <div class="order_preview_label">支付方式</div>
          <div class="order_preview_value">{{list.pay_type_str}}</div>
        </div>
        <div class="order_preview_item1">
          <div class="order_preview_label">订单编号</div>
          <div class="order_preview_value">{{list.order_no}}</div>
        </div>
        <div class="order_preview_item1">
          <div class="order_preview_label">订单时间</div>
          <div class="order_preview_value">{{list.created_at}}</div>
        </div>
        <div class="order_preview_item1" v-if="list.remark">
          <div class="order_preview_label">备注</div>
          <div class="order_preview_value">{{list.remark}}</div>
        </div>
      </div>
      <div class="order_preview_ft">
        <div class="order_preview_btn order_preview_btn_primary" @click="pageToIndex">
          <a>返回首页</a>
        </div>
      </div>
    </div>
    <div class="order_preview" v-else>
      <div class="order_preview_bd">
        <div class="order_preview_item">
          <div class="order_preview_label">订单名称</div>
          <div class="order_preview_value">{{list.type=='second_order' ? list.name : list.product_name && list.product_name}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单编号</div>
          <div class="order_preview_value">{{list.order_no}}</div>
        </div>
        <div class="order_preview_item" v-if="list.type=='online'">
          <div class="order_preview_label">充值账号</div>
          <div class="order_preview_value">{{list.recharge_number}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单时间</div>
          <div class="order_preview_value">{{list.created_at}}</div>
        </div>
        <div class="order_preview_item" v-if="list.type!='second_order'">
          <div class="order_preview_label">商品总价</div>
          <div class="order_preview_value">￥{{list.product_price}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单金额</div>
          <div class="order_preview_value">￥{{list.amount}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">实付金额</div>
          <div class="order_preview_value">￥{{list.paid_amount}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">支付方式</div>
          <div class="order_preview_value">{{list.pay_type_str}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">支付状态</div>
          <div class="order_preview_value">{{list.pay_status_str}}</div>
        </div>
        <div class="order_preview_item" v-if="list.orderStatus == 40">
          <div class="order_preview_label">待支付</div>
          <div class="order_preview_value">￥{{list.orderMoney}}</div>
        </div>
        <div class="order_preview_item" v-if="list.orderStatus == 40">
          <div class="order_preview_label">取消时间</div>
          <div class="order_preview_value">{{list.cancelTime}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单状态</div>
          <div class="order_preview_value">{{list.order_status_str}}</div>
        </div>
        <div v-if="list.recharge_data">
          <div v-for="(item,index) in JSON.parse(list.recharge_data)">
            <div class="order_preview_item" v-if="item.goods_number">
              <div class="order_preview_label">卡号</div>
              <div class="order_preview_value">{{item.goods_number}}</div>
            </div>
            <div class="order_preview_item" v-if="item.goods_password">
              <div class="order_preview_label">卡密</div>
              <div class="order_preview_value">{{item.goods_password}}</div>
            </div>
            <div class="order_preview_item" v-if="item.goods_link">
              <div class="order_preview_label">链接</div>
              <div class="order_preview_value">{{item.goods_link}}</div>
            </div>
            <div class="order_preview_item" v-if="item.effective_time">
              <div class="order_preview_label">有效期</div>
              <div class="order_preview_value">{{item.effective_time}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="order_preview_ft">
        <div class="order_preview_btn order_preview_btn_primary" @click="pageToIndex()">
          <a>返回首页</a>

        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
  import httper from '../../api/http';

  export default {
    data() {
      return {
        id: '', // 上一页面获取参数,默认为空
        list: [], //获取详情列表参数,默认为空
        timechao: false, //判断对比当前时间是否大于订单时间，默认为false
        currentTime: '', // 倒计时,默认为空
        navIndex: 0 //上一页面获取指针参数
      }
    },
    created() {
      let that = this
      //上一页面传过来的参数
      if (that.$route.query.navIndex) {
        that.navIndex = that.$route.query.navIndex
      }
      if (that.$route.query.id) {
        that.id = that.$route.query.id
      } else {
        if (!that.id) {
          this.$toast({
            message: '参数错误',
          })
          setTimeout(function() {
            history.back()
          }, 1000)
          return
        }
      }

      this.request('getDetail', {
        order_no: that.id
      })
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      fanhui() {
        // this.$router.go(-1);
        this.$router.push({
          path: "/",
          query: {
            order_status: this.navIndex
          }
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取订单详情
          case 'getDetail':
            httper.get('order/get-by-order-no', requestData, res => {
              if (res.code === 0) {
                // 初始化数据
                let dingmine = Number(res.data.created_at2) + 1800
                let nowtime = new Date();
                let nowmine = Number(nowtime.getTime() / 1000)
                let timechao = dingmine - nowmine > 0
                let timeqia = dingmine - nowmine
                let time = parseInt(timeqia % 60)
                let minutes = parseInt(timeqia / 60)
                this.list = res.data
                this.timechao = timechao

                if (res.data.order_status == 0 && timechao) {
                  //倒计时
                  let interval = setInterval(() => {
                    time--
                    if (time >= 10) {
                      that.currentTime = minutes + '分' + time + '秒'
                    }
                    if (time > 0 && time < 10) {
                      that.currentTime = minutes + '分' + '0' + time + '秒'
                    }
                    if (time <= 0) {
                      if (minutes > 0) {
                        minutes--;
                        time = 60;
                        that.currentTime = minutes + '分' + time + '秒'
                      } else {
                        clearInterval(interval);
                        that.currentTime = ''
                      }
                    }
                  }, 1000)
                }
              } else {
                this.$toast({
                  message: res.message || '系统错误',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>
<style scoped>
  .list_top {
    background-image: url(../../../static/newprojecticon/zhifubg.png);
    background-size: contain;
    height: 153px;
  }

  .icon {
    width: 100%;
    height: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .iconimg {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }

  .icon_text {
    font-size: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .order_preview {
    position: relative;
    background-color: #fff;
    position: absolute;
    top: 180px;
    /* width: 90%; */
    width: calc(100% - 40px);
    margin: 0 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 0px 0px 8px 8px;
  }

  .order_preview:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.1);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .order_preview_bd {
    padding: 16px;
    box-sizing: border-box;
    font-size: 0.9em;
    text-align: right;
    color: rgba(0, 0, 0, 0.5);
    line-height: 2;
  }

  .order_preview_item {
    /* overflow: hidden; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .order_preview_item1 {
    /* overflow: hidden; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .order_preview_label {
    /* float: left;
    margin-right: 1em; */
    /* min-width: 4em; */
    color: rgba(0, 0, 0, 0.5);
    text-align: justify;
    -moz-text-align-last: justify;
    text-align-last: justify;
  }

  .order_preview_value {
    display: block;
    overflow: hidden;
    word-break: normal;
    word-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
  }

  .order_preview_ft {
    position: relative;
    line-height: 50px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .order_preview:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.1);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .order_preview_btn_primary {}

  .order_preview_btn {
    position: relative;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .orderDenone {
    width: 100%;
    height: 240px;
  }

  .fanhuiindex {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FD8C00;
  }

  .order_product_address {
    display: flex;
    border-bottom: 1px solid #E5E5E5;
    align-items: center;
    text-align: start;
  }

  .order_product_addressicon {
    /* width: 10%;
    margin-right: 10px;
    height: 36px; */
    width: 6%;
    height: 20px;
    margin-right: 10px;

  }

  .order_product_addressmesg {
    width: 90%;
  }

  .order_product_addressname {
    font-size: 15px;
    display: flex;
    /* margin-bottom: 10px; */
    color: #000000;
  }

  .order_product_addressphone {
    margin-left: 10px;
  }

  .order_product_addressdetail {
    font-size: 12px;
    color: #666666;
    margin-bottom: 5px;
  }

  .order_product_detail {
    display: flex;
    align-items: center;
    margin: 15px 0;
  }

  .order_product_detailimg {
    width: 17%;
    height: 58px;
    margin-right: 10px;
    border-radius: 8px;
  }

  .order_product_detailthum {
    width: 100%;
    height: 100%;
    border-radius: 8px;

  }

  .order_product_detailmesg {
    width: 80%;
    text-align: start;
  }

  .order_product_detailproname {
    font-size: 12px;
    margin-bottom: 10px;
    color: #000000;
  }

  .order_product_detailbottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .order_product_detailguige {
    color: #666666;
  }

  .order_product_detailprice {
    color: #FD8C00;
  }

  .ordertoppage {
    width: 100%;
    background-color:#FD8C00;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .ordericonimg {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }

  .ordericontext {
    font-size: 15px;
    font-weight: 400;
    color: #FFFFFF;
  }

  .orderdetaillist {
    width: calc(100% - 40px);
    margin: 20px;
    position: absolute;
    top: 150px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);

  }

  .orderdetailbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .orderreturnindex {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.5);
  }

  .orderdetailname {
    width: 50%;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
  }

  .orderdetailvalue {
    font-size: 14px;
    width: 50%;
    text-align: end;
  }
</style>



// WEBPACK FOOTER //
// src/pages/alipaypage/alipayorderDetail.vue